import { Location, Route } from "vue-router";

export const mergeReturnUrl = (currentRoute: Route, targetRoute: Location) => {
  if (currentRoute.query && currentRoute.query.returnUrl) {
    const query = { returnUrl: currentRoute.query.returnUrl };
    return { ...targetRoute, query };
  }
  return targetRoute;
};